import { render, staticRenderFns } from "./custom-title-type-1.vue?vue&type=template&id=7c19a13f&scoped=true&"
import script from "./custom-title-type-1.vue?vue&type=script&lang=js&"
export * from "./custom-title-type-1.vue?vue&type=script&lang=js&"
import style0 from "./custom-title-type-1.vue?vue&type=style&index=0&id=7c19a13f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c19a13f",
  null
  
)

export default component.exports